import { z } from "zod";
import { localStore } from "../../../lib/store";

/**
 * Set once a user has authenticated on this install. Never cleared on logout —
 * used by the router and the deferred-deep-link hook to decide whether this is
 * a fresh install (show welcome / run DDL) or a returning session.
 */
export const hasLoggedInStore = localStore("hasLoggedIn", false, z.boolean());

/**
 * Set once the deferred-deep-link hook has redirected this device. Prevents
 * re-triggering DDL on subsequent app launches.
 */
export const hasUsedDDLStore = localStore("hasUsedDDL", false, z.boolean());
